// extracted by mini-css-extract-plugin
export default {"participantLink":"KioskDashboard_participantLink__oM7e-"};